import {useCallback, useEffect, useState} from 'react'
import UseCancelToken from './UseCancelToken'
import SettingsService from '../../app/modules/settings/core/_requests'

export const useIntegrationStores = (fetchOnMount = false) => {
  const {newCancelToken, isCancel} = UseCancelToken()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchIntegrationStores = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await SettingsService.connections({cancelToken: newCancelToken()})
      setData(response.connections)
      return response.connections
    } catch (err) {
      if (isCancel(err)) return null
      setError(err instanceof Error ? err : new Error('Failed to fetch integration stores'))
      return null
    } finally {
      setLoading(false)
    }
  }, [isCancel, newCancelToken])

  useEffect(() => {
    if (fetchOnMount) {
      fetchIntegrationStores()
    }
  }, [fetchOnMount, fetchIntegrationStores])

  return {
    data,
    loading,
    error,
    fetchIntegrationStores,
  }
}
